export const SITE_METADATA = {
  siteName: "FPEP Bar",
  brandName: "Fakultet za poslovnu ekonomiju i pravo Bar",
  siteUrl: "https://fpep.me",
  logoImage: "/assets/img/logo/fpeplogo.png",
  defaultOgImage: "/assets/img/social/fpep-campus.webp",
  defaultOgImageAlt: "Fakultet za poslovnu ekonomiju i pravo Bar",
  defaultOgImageType: "image/webp",
  defaultOgImageWidth: 1200,
  defaultOgImageHeight: 630,
  contactEmail: "fpebar@gmail.com",
  internationalEmail: "international@fpebar.me",
  phone: "+38268003113",
  alternatePhone: "+38268011311",
  streetAddress: "Rista Lekića 16",
  addressLocality: "Bar",
  postalCode: "85000",
  addressCountry: "ME",
};

export const DEFAULT_SEO = {
  title: "FPEP Bar | Fakultet za poslovnu ekonomiju i pravo",
  description:
    "Fakultet za poslovnu ekonomiju i pravo Bar — studijski programi iz ekonomije, menadžmenta i prava, upis, Erasmus, međunarodni projekti i studentski život.",
  pageType: "WebSite",
  breadcrumbs: [{ name: "Početna", path: "/" }],
};

export default SITE_METADATA;
